const PHONE_PATTERN = /^[\d+\-\s().]+$/;

function sanitizeTelNumber(raw) {
  if (raw == null || typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed || !PHONE_PATTERN.test(trimmed)) return null;
  return trimmed.replace(/\s/g, "");
}

export { sanitizeTelNumber };
